declare global {
  interface Window {
    env: any;
  }
}
type EnvType = {
  REACT_APP_API_HOST: string;
  REACT_APP_DASHBOARD_URL: string;
  REACT_APP_DASHBOARD_ANAL_LINK_URL: string;
  REACT_APP_SSO_URL: string;
  REACT_APP_LANG_TYPE: string;
  REACT_APP_FILE_SIZE: number;
  REACT_APP_IMAGE_FILE_SIZE: number;
};
export const env: EnvType = { ...process.env, ...window.env };
